import React from "react";

function MFEButton({ onClick, label, disabled, color }) {
  // Determine the background color based on the color prop or use default styles
  const backgroundColor = color === "red" ? "bg-red-500" : "bg-[#005296] dark:bg-[#083F6C]";

  return (
    <button
      onClick={() => {
        if (!disabled) {
          onClick(); // Only call onClick if not disabled
        }
      }}
      className={`flex justify-center w-full ${backgroundColor} rounded-lg hover:bg-gradient-to-r from-dark-primary via-[#005296] to-dark-primary dark:hover:bg-none dark:hover:border dark:hover:border-solid dark:hover:border-dark-border text-white p-[0.979rem] ${
        disabled
          ? "opacity-50 cursor-not-allowed" // Light shade style for disabled state
          : ""
      }`}
      disabled={disabled} // Add the disabled attribute
    >
      <p>{label}</p>
    </button>
  );
}

export default MFEButton;
